<template>
    <div>
        <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
            <div v-if="this.isMobile">
                <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
            </div>
            <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
                {{ this.$store.state.modal.content.title }}
            </div>
            <div v-if="!this.isMobile">
                <Icon name="close" class="c24 pointer" @click="this.close()"/>
            </div>
        </div>
        <div class="p24 mb-0 content">
            <div class="d-flex flex-column gap16">
                <div>
                    <label class="fsp14 lh20 text-black neue-roman mb8 d-block">
                        {{ this.$t('views.P2P.SingleSwap.3') }}
                    </label>
                    <InputSimple
                        type="textarea"
                        id="admin_comment"
                        :dataValue="admin_comment"
                        :placeholder="this.$t('views.P2P.SingleSwap.49')"
                        @updateParentState="updateState"
                    />
                </div>
                <div class="neue-roman fsp14 lh20 text-black">
                    <div class="mb16">{{ $t('components.service.modal.p2p.CancelAdmin.1') }}</div>
                    <div>{{ $t('components.service.modal.p2p.CancelAdmin.2') }}</div>
                </div>
            </div>
            <div class="d-flex mt24" :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }">
                <Button 
                    type="btn-outline-warning" 
                    class="equal-width h48 mr16 status-text-red border-full" 
                    @click="this.save()"
                >
                    {{ $t('components.service.modal.p2p.CancelAdmin.3') }}
                </Button>
                <Button 
                    type="btn-outline-grey" 
                    class="equal-width h48 primary-grey" 
                    @click="this.clearAll()"
                >
                    {{ $t('components.service.modal.p2p.CancelAdmin.4') }}
                </Button>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/icons/Icon'
import Button from '@/components/service/Button'
import InputSimple from '@/components/service/InputSimple'

export default {
    name: 'CancelAdmin',
    components: {
        Icon,
        Button,
        InputSimple
    },
    props: {
        close: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            admin_comment: ''
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.isMobile
        }
    },
    methods: {
        updateState(state) {
            this[state.id] = state.value;
        },
        save() {
            if (this.$store.state.modal.content.callback) {
                this.$store.state.modal.content.callback(this.admin_comment);
            }
            this.close();
        },
        clearAll() {
            this.close();
        }
    }
}
</script>
<style scoped lang="scss">
    textarea.textarea-min-height {
        min-height: 100px;
        
        &::placeholder {
            color: $primary-grey;
        }
    }
</style>
